import React from 'react';

import Clipper from 'src/app/clipper/Clipper';

import { Landing as LandingNew } from '../landing-new';

const ClipperContainer = ({ params, location }) =>
  location.query.url || location.query.file ? (
    <Clipper viewParams={params} query={location.query} />
  ) : (
    <LandingNew slug="clipper" />
  );

export default ClipperContainer;
